import React from 'react';
import { Avatar } from '@mui/material';
import './style.css';

/**
 * PersonRow atom
 * Fila individual de persona con avatar, datos y badge.
 * Inspirado directamente del TeamCollaboration de Tasko.
 *
 * Props:
 *  - name: string
 *  - subtitle?: string (ej: "Working on X", "Proveedor", "Cajero")
 *  - status?: string (clave: 'completed'|'in-progress'|'pending'|'error')
 *  - statusLabel?: string (texto del badge)
 *  - avatarUrl?: string
 *  - avatarInitial?: string
 *  - onClick?: () => void
 *  - className?: string
 */
function PersonRow({
    name,
    subtitle,
    status,
    statusLabel,
    avatarUrl,
    avatarInitial,
    onClick,
    className = '',
    renderActions,
}) {
    const initial = avatarInitial || (name ? name.charAt(0).toUpperCase() : '?');

    return (
        <div
            className={`person-row${onClick ? ' person-row--clickable' : ''} ${className}`}
            onClick={onClick}
            role={onClick ? 'button' : undefined}
            tabIndex={onClick ? 0 : undefined}
        >
            <Avatar
                src={avatarUrl || null}
                className="person-row-avatar"
            >
                {!avatarUrl && initial}
            </Avatar>
            <div className="person-row-body">
                <span className="person-row-name">{name}</span>
                {subtitle && (
                    <span className="person-row-subtitle">{subtitle}</span>
                )}
                {status && (
                    <span className={`person-row-status person-row-status--${status}`}>
                        {statusLabel || status}
                    </span>
                )}
            </div>
            {renderActions}
        </div>
    );
}

export default PersonRow;
